// Local translations
export const T = {
  en_GB: {
    description:
      "Define the account wrapper types available in this collection (e.g. ASK, IPS). On each product you then pick which wrapper types it may be held in, in order of preference.",
    noWrapperTypes: 'No wrapper types configured. Click "Add Wrapper Type" to create one.',
    name: "Name",
    syncKey: "Sync key",
    syncKeyPlaceholder: "e.g., ask",
    syncKeyDescription:
      "Identifier used to match this wrapper type when syncing external products. Unique within the collection, case-sensitive. Not shown to clients.",
    syncKeyRequired: "Sync key is required",
    minAccountValue: "Minimum account value",
    minAccountValueOptional: "optional",
    minAccountValueDescription:
      "Flows are blocked at submit while an account of this wrapper type would hold less than this amount. Leave empty for no minimum.",
    minAccountValueInvalid:
      "Minimum account value must be a whole number greater than zero and at most 2,147,483,647",
    active: "Active",
    actions: "Actions",
    addWrapperType: "Add Wrapper Type",
    editWrapperType: "Edit Wrapper Type",
    createDialogDescription: "Give the wrapper type a name shown in the product configuration.",
    namePlaceholder: "e.g., ASK",
    save: "Save",
    cancel: "Cancel",
    deleteWrapperType: "Delete Wrapper Type",
    deleteDescription:
      "Are you sure you want to delete this wrapper type? Deleting is only possible while no product references it.",
    delete: "Delete",
    error: "Error",
    failedToAdd: "Failed to add wrapper type",
    failedToUpdate: "Failed to update wrapper type",
    failedToDelete: "Failed to delete wrapper type",
    failedToToggle: "Failed to change active state",
    nameRequired: "Name is required",
  },
  nb_NO: {
    description:
      "Definer innpakningstypene for kontoer i denne samlingen (f.eks. ASK, IPS). På hvert produkt velger du deretter hvilke innpakningstyper det kan holdes i, i prioritert rekkefølge.",
    noWrapperTypes:
      'Ingen innpakningstyper konfigurert. Klikk "Legg til innpakningstype" for å opprette en.',
    name: "Navn",
    syncKey: "Synkroniseringsnøkkel",
    syncKeyPlaceholder: "f.eks., ask",
    syncKeyDescription:
      "Identifikator som brukes til å koble denne innpakningstypen ved synkronisering av eksterne produkter. Unik innenfor samlingen, skiller mellom store og små bokstaver. Vises ikke til kunder.",
    syncKeyRequired: "Synkroniseringsnøkkel er påkrevd",
    minAccountValue: "Minste kontoverdi",
    minAccountValueOptional: "valgfritt",
    minAccountValueDescription:
      "Flyter blokkeres ved innsending så lenge en konto av denne innpakningstypen ville hatt mindre enn dette beløpet. La stå tomt for ingen minimumsverdi.",
    minAccountValueInvalid:
      "Minste kontoverdi må være et helt tall større enn null og maksimalt 2 147 483 647",
    active: "Aktiv",
    actions: "Handlinger",
    addWrapperType: "Legg til innpakningstype",
    editWrapperType: "Rediger innpakningstype",
    createDialogDescription: "Gi innpakningstypen et navn som vises i produktkonfigurasjonen.",
    namePlaceholder: "f.eks., ASK",
    save: "Lagre",
    cancel: "Avbryt",
    deleteWrapperType: "Slett innpakningstype",
    deleteDescription:
      "Er du sikker på at du vil slette denne innpakningstypen? Sletting er bare mulig så lenge ingen produkter refererer til den.",
    delete: "Slett",
    error: "Feil",
    failedToAdd: "Kunne ikke legge til innpakningstype",
    failedToUpdate: "Kunne ikke oppdatere innpakningstype",
    failedToDelete: "Kunne ikke slette innpakningstype",
    failedToToggle: "Kunne ikke endre aktiv-status",
    nameRequired: "Navn er obligatorisk",
  },
} as const;
